import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ISettingsConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISettingsConfig';
import IRulesScenes from '../../vendor_core/core/src/managers/contracts/configurations/settings/IRulesScenes';
import ISettingsRulesData from '../../vendor_core/core/src/managers/contracts/configurations/settings/ISettingsRulesData';

class SettingsConfig implements ISettingsConfig {
    type: ConfigurationTypes = ConfigurationTypes.SETTINGS;
    rulesScenes: IRulesScenes = {
        gameRules: "gamerules",
        paytable: "paytable",
        featureRules: "featurerules",
        autoplayRules: "autoplayrules",
    };

    biggestTextScene: string = "featurerules~1";
    biggestTextTextField: string = "bb_wild_rules_1";
    scenesForCalculatingMinFontSize: string[] = [
        "gamerules~1",
        "gamerules~2",
        "gamerules~3",
        "gamerules~4",
        "featurerules~1",
        "featurerules~2",
        "featurerules~3",
        "featurerules~4",
        "autoplayrules~1",
        "paytable~1",
        "paytable~2",
    ];
    /**
     * @param name First part of the key for rules defined in localization (without the number of the end of the key)
     * @param rules This represents the rules which will be seen on one rules page in settings
     * - "from" (`rules[0]`) number of define in localization rules
     * - "to" (`rules[1]`) number of define in localization rules
     * @param sceneTextField This is the name of the body text field in PSD who is collecting all visible rules on one setting page
     */
    rulesData: ISettingsRulesData[] = [
        {
            name: "bb_freespin_rules_",
            rulesDimensions: [1, 4],
            sceneTextField: "bb_freespin_rules_1",
        },
        {
            name: "bb_autoplay_rules_",
            rulesDimensions: [1, 4],
            sceneTextField: "bb_autoplay_rules_1",
        },
        {
            name: "bb_wild_rules_",
            rulesDimensions: [1, 4],
            sceneTextField: "bb_wild_rules_1",
        },
        {
            name: "bb_wild_rules_",
            rulesDimensions: [5, 7],
            sceneTextField: "bb_wild_rules_2",
        },
        {
            name: "bb_destroy_rules_",
            rulesDimensions: [1, 3],
            sceneTextField: "bb_destroy_rules_1",
        },
        {
            name: "bb_game_rules_",
            rulesDimensions: [1, 4],
            sceneTextField: "bb_game_rules_1",
        },
        {
            name: "bb_game_rules_",
            rulesDimensions: [5, 8],
            sceneTextField: "bb_game_rules_2",
        },
        {
            name: "bb_game_rules_",
            rulesDimensions: [9, 11],
            sceneTextField: "bb_game_rules_3",
        },
        {
            name: "bb_feature_bye_rules_",
            rulesDimensions: [1, 4],
            sceneTextField: "bb_game_rules_4",
        },
    ];
    applyMinFontSizeTextFields: string[] = [
        "paytable_info",
        "paytable_description_general",
        "paytable_description_wild",
        "ui_background_music",
        "ui_sounds",
    ];

    forceCalculateBound: string[] = [
        "ui_game_rules",
        "ui_wild_rules",
        "ui_destroy_rules",
        "ui_freespin_rules",
        "paytable_symbol_wins",
    ]


}

export default new SettingsConfig()
